// extracted by mini-css-extract-plugin
module.exports = {"box_item":"AutoplayVideoItem_theme1_box_item__gpWJJ","heading":"AutoplayVideoItem_theme1_heading__at2vm"};